import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductionCapacityChartPage } from "src/components/views/erp/production/reports/productionCapacityChart/ProductionCapacityChartPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/production/capacity")({
	staticData: { title: i18n.t("capacity"), legacyViewKey: "productionCapacityChartPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductionCapacityChartPage />;
}
